import { Component, OnInit } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { LoaderService } from '../../services/loader-service/loader.service'

@Component({
  selector: 'app-support-layout',
  templateUrl: './support-layout.component.html',
  styleUrls: ['./support-layout.component.scss'],
})
export class SupportLayoutComponent implements OnInit {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.loaderService.updateLoader(false)
    }, 500)
  }
}
